<template>
  <div class="page page-drivers">
    <h3>Создание нового водителя</h3>
    <div class="row">
      <div class="col-md-4 mb-2">
        <label>Фамилия</label>
        <input type="text" class="form-control" v-model="driver.last_name" placeholder required>
      </div>
      <div class="col-md-3 mb-2">
        <label>Имя</label>
        <input type="text" class="form-control" v-model="driver.first_name" placeholder required>
      </div>
      <div class="col-md-4 mb-2">
        <label>Отчество</label>
        <input type="text" class="form-control" v-model="driver.middle_name" placeholder required>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 mb-5">
        <label>Телефон</label>
        <imask-input
              type="text"
              name="phone"
              class="form-control"
              v-model="driver.phone"
              :mask="'+{7} (000) 000-00-00'"
              :unmask='false'
              placeholder='+7 (000) 000-00-00'
            />
      </div>
       <div class="col-md-4 mb-6">
        <label>Адрес проживания</label>
        <dadata-suggestions
          type="ADDRESS"
          class="form-control"
          v-model="driver.address"
        />
      </div>
    </div>
    <div class="row">

    </div>
    <hr class="mb-4" />
    <button class="btn btn-primary" @click="createDriver()">Создать</button>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import DriversAPI from '@/api/drivers'

export default {
  name: 'CreateDriver',
  data () {
    return {
      isCreating: false,
      driver: {
        last_name: '',
        middle_name: '',
        first_name: '',
        phone: '',
        address: ''
      }
    }
  },
  methods: {
    createDriver () {
      if (this.isCreating) {
        return
      }
      this.isCreating = true
      DriversAPI.createItem(this.driver)
        .then(driver => {
          this.isCreating = false
          this.$router.push('/drivers')
        })
        .catch(text => {
          this.isCreating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    }
  }
}
</script>
<style scoped>
  .page-drivers h3 {
    float: none;
    margin-bottom: 3rem;
  }
  .page-drivers .btn-primary {
    float: right;
    margin-right: 2rem;
  }
</style>
